import React, { useContext, useEffect, useState } from 'react';
import CustomLocationCard from '../locations/locationCard/CustomLocationCard';
import CustomUnitscard, { units } from '../units/unitscard/CustomUnitCard';
import styles from './appointmentConfirmation.module.css';
import { AppDispatch, IRootState } from '../../redux/rootReducer';
import { useSelector } from 'react-redux';
import moment from 'moment';
import PhoneInput from 'react-phone-input-2';
import '../../index.css';
import { IAppointmentConfirmation } from './interface/AppointmentConfirmation.interface';
import { tableHeader } from '../../constants/constants';
import { useDispatch } from 'react-redux';
import { getUnitById } from '../../redux/units/actions/unitById.action';
import { AvailabilityRedirectionContext } from '../context/availabilityRedirection';
import Loader from '../common/loader/Loader';

const AppointmentConfirmation = ({ slotRange, userData, locationDetail, selectedDate, selectedUnit }: IAppointmentConfirmation) => {
    const availabilityRedirectionContext = useContext(AvailabilityRedirectionContext);

    const units = useSelector((state: IRootState) => state.createAppoinmentReducer?.locationById?.data?.units);

    const { data } = useSelector((state: IRootState) => state.createAppoinmentReducer.unit);

    const unitDetails = useSelector((state: IRootState) => state.unitById.data?.unit);
    const unitsDetailsLoading = useSelector((state: IRootState) => state.unitById?.loading);

    const dispatch = useDispatch<AppDispatch>();

    const [unit, setUnit]: any = useState();

    useEffect(() => {
        if (data && Object.keys(data).length) {
            availabilityRedirectionContext?.setData(data);
        }
    }, [data]);

    useEffect(() => {
        dispatch(getUnitById(selectedUnit ? selectedUnit : availabilityRedirectionContext?.availabilityData.unitId, true));
    }, [selectedUnit]);

    useEffect(() => {
        const temp = units?.find((el: { unitId: string }) => el.unitId === selectedUnit);
        setUnit(temp);
    }, [selectedUnit, units]);

    return (
        <div className={styles.confirmationContainer}>
            <div className={`${styles.listingContainer} listingContainer`}>
                <table>
                    <thead>
                        <tr>
                            {tableHeader?.length &&
                                tableHeader?.map((item, index) => {
                                    return <th key={index.toString()}>{item.title}</th>;
                                })}
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>{(userData?.name ? userData : availabilityRedirectionContext?.selectedUserTableData)?.name}</td>
                            <td>{(userData?.email ? userData : availabilityRedirectionContext?.selectedUserTableData)?.email}</td>
                            <td className={`${styles.noWrap} phone-col`}>
                                <PhoneInput
                                    value={String(
                                        `+${(userData?.countryCode ? userData : availabilityRedirectionContext?.selectedUserTableData)
                                            ?.countryCode
                                        }${(userData?.contact ? userData : availabilityRedirectionContext?.selectedUserTableData)?.contact
                                        }`,
                                    )}
                                    disabled
                                />
                            </td>
                            <td>
                                {(userData?.locationName ? userData : availabilityRedirectionContext?.selectedUserTableData)?.locationName}
                            </td>
                            <td className={styles.noWrap}>
                                {(userData?.date ? userData : availabilityRedirectionContext?.selectedUserTableData)?.date &&
                                    moment((userData?.date ? userData : availabilityRedirectionContext?.selectedUserTableData)?.date)
                                        .utc()
                                        .format('MM-DD-YYYY')}
                            </td>
                            <td>
                                {(userData?.bedrooms ? userData : availabilityRedirectionContext?.selectedUserTableData)?.bedrooms === '0'
                                    ? 'Studio'
                                    : (userData?.bedrooms ? userData : availabilityRedirectionContext?.selectedUserTableData)?.bedrooms}
                            </td>
                            <td>
                                {(userData?.companyName ? userData : availabilityRedirectionContext?.selectedUserTableData)?.companyName}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

            {unitsDetailsLoading ? (
                <Loader />
            ) : (
                <div className={styles.propertyDetails}>
                    <div className={styles.locationContainer}>
                        <h2>Property</h2>
                        <div className={styles.locationCard}>
                            <CustomLocationCard location={locationDetail} noPointer={true} />
                        </div>
                    </div>
                    <div className={styles.unitContainer}>
                        <h2>Selected Unit</h2>
                        <div className={styles.unitContainer}>
                            <CustomUnitscard unit={unitDetails} noPointer={true} />
                        </div>
                    </div>
                </div>
            )}

            {(selectedDate && slotRange) ||
                (availabilityRedirectionContext?.availabilityData?.selectedDate &&
                    availabilityRedirectionContext.availabilityData?.slotRange) ? (
                <div className={styles.appointmentDateTime}>
                    <div className={styles.appointmentDate}>
                        <h2>Date</h2>
                        <p>
                            {moment(
                                (availabilityRedirectionContext && availabilityRedirectionContext.availabilityData.selectedDate) ||
                                selectedDate,
                            )
                                .locale('en')
                                .format('MM-DD-YYYY')}
                        </p>
                    </div>
                    <div className={styles.appointmentDate}>
                        <h2>Time</h2>
                        <p>
                            {availabilityRedirectionContext &&
                                `${moment(
                                    (slotRange || availabilityRedirectionContext.availabilityData.slotRange).split('-')[0],
                                    'h:mm A',
                                ).format('h:mm A')} to ${availabilityRedirectionContext &&
                                moment(
                                    (slotRange || availabilityRedirectionContext.availabilityData.slotRange).split('-')[1],
                                    'h:mm A',
                                ).format('h:mm A')
                                }`}
                        </p>
                    </div>
                </div>
            ) : null}
        </div>
    );
};

export default AppointmentConfirmation;
